module.exports = __webpack_public_path__ + "img/desktop_cover_d.7a497317.png";